import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { RefreshCw, X } from 'lucide-react';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    // Listen for custom event when service worker is waiting
    const handleWaiting = (event) => {
      console.log('[UpdateNotification] Service worker waiting detected');
      setWaitingWorker(event.detail);
      setShowUpdate(true);
    };

    window.addEventListener('sw-waiting', handleWaiting);

    // Also listen for service worker messages
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'NEW_VERSION_AVAILABLE') {
          console.log('[UpdateNotification] Received NEW_VERSION_AVAILABLE message');
          setShowUpdate(true);
        }
      });
    }

    return () => {
      window.removeEventListener('sw-waiting', handleWaiting);
    };
  }, []);

  const handleRefresh = () => {
    console.log('[UpdateNotification] User clicked refresh');
    if (waitingWorker) {
      // Tell the waiting service worker to skip waiting
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      // The page will reload automatically when controller changes
    } else {
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-slide-down">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-2xl p-4 flex items-center gap-4 border-2 border-blue-400 min-w-[300px] max-w-[90vw]">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <RefreshCw className="w-5 h-5 animate-spin" />
            <p className="font-bold text-base">Update Available!</p>
          </div>
          <p className="text-sm text-blue-100">
            A new version is ready. Pull down or tap refresh to update.
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            onClick={handleRefresh}
            className="bg-white text-blue-600 hover:bg-blue-50 font-bold"
            size="sm"
          >
            <RefreshCw className="w-4 h-4 mr-1" />
            Refresh
          </Button>
          <Button
            onClick={handleDismiss}
            variant="ghost"
            className="text-white hover:bg-blue-500"
            size="sm"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
